import { graphql } from "react-relay";

export const CreateTeamMutation = graphql`
  mutation CreateTeamMutation($input: CreateTeamInput!) {
    createTeam(input: $input) {
      team {
        id
        name
        description
      }
    }
  }
`;
